export class IsSticky {
    constructor() {
        const stickyElements = [].slice.call(document.querySelectorAll('[data-sticky]'));
        // Do nothing if no intersection observer
        if (!('IntersectionObserver' in window))
            return;
        if (stickyElements.length > 0) {
            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(function (entry) {
                    if (entry.intersectionRatio === 1) {
                        entry.target.classList.remove('is-pinned');
                    }
                    else if (entry.intersectionRatio < 1) {
                        entry.target.classList.add('is-pinned');
                    }
                });
            }, { threshold: [1] });
            stickyElements.forEach(function (sticky) {
                observer.observe(sticky);
            });
        }
    }
}
